import SalaryInput from './salary-input'

export default SalaryInput
